// extracted by mini-css-extract-plugin
export default {"mainTitle":"styles_mainTitle__ecJhE","secondTitle":"styles_secondTitle__RuEM6"};